import React, { useCallback, useEffect } from 'react';
import { Tappable } from '@vectord/components';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import cogoToast from 'cogo-toast';

import { DEFAULT_ERROR_MESSAGE } from 'data/defaultErrorMessage';
import {
  getOrderedCoreMenteeModules,
  MANAGE_MENTEE_MODULES_PAGE_TRACKINGS,
  orderedCoreMenteeModulesSelector,
  setMenteeModules,
  useBulkReorderMenteeModulesMutation,
  useGetMenteeModulesQuery,
  viewMiscellaneousMenteeModulesStateSelector,
} from 'features/moduleManagement';
import analytics from 'utils/analytics';
import GlobalLoader from 'components/GlobalLoader';

function SaveOrderChangesButton() {
  const dispatch = useDispatch();
  const { email } = useParams();
  const { data } = useGetMenteeModulesQuery(email);
  const menteeModules = useSelector(orderedCoreMenteeModulesSelector);
  const isMiscMenteeModules = useSelector(
    viewMiscellaneousMenteeModulesStateSelector
  );
  const [bulkReorderMenteeModules, { isLoading: isMoving, isSuccess, error }] =
    useBulkReorderMenteeModulesMutation();

  const handleOnClick = useCallback(() => {
    const previousOrderedMenteeModules = getOrderedCoreMenteeModules(
      data?.data
    );
    const reorderedMenteeModules = menteeModules.map((mm) => ({
      mentee_module_id: mm.id,
      order: mm.order,
    }));

    analytics.click({
      click_type: MANAGE_MENTEE_MODULES_PAGE_TRACKINGS.reorderMenteeModules,
      custom: {
        previous_ordered_mentee_modules: previousOrderedMenteeModules,
        reordered_mentee_modules: reorderedMenteeModules,
        mentee_email: email,
      },
    });

    bulkReorderMenteeModules(reorderedMenteeModules);
  }, [bulkReorderMenteeModules, menteeModules, data, email]);

  useEffect(() => {
    if (isSuccess) {
      cogoToast.success('Module Order changed successfully');
    }
  }, [isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(error?.data?.message || DEFAULT_ERROR_MESSAGE);
      dispatch(setMenteeModules(data.data));
    }
  }, [data.data, dispatch, error]);

  if (!isMiscMenteeModules) {
    return (
      <>
        <GlobalLoader isVisible={isMoving} />
        <Tappable
          className="btn btn-primary"
          onClick={handleOnClick}
          disabled={isMoving}
        >
          Save Order Changes
        </Tappable>
      </>
    );
  }
  return null;
}

export default SaveOrderChangesButton;
